import {
  Skeleton,
  SkeletonCard,
  SkeletonText,
  SkeletonTitle,
} from '../SkeletonComponents';

/**
 * Skeleton for the Summary tab CONTENT ONLY
 * Used within GroupPageLayout - no header or tabs included
 * Matches: GroupDetailPage (widgets + expenses section)
 */
export function SummaryContentSkeleton() {
  return (
    <>
      {/* Widget Grid - matches exact layout from real component */}
      <div className="grid grid-cols-1 gap-3 sm:gap-4 mb-3 sm:mb-4">
        {/* Row 1: Invitation Link - Full width */}
        <SkeletonCard className="p-4">
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Skeleton className="w-5 h-5" />
                <SkeletonText className="w-40 h-5" />
              </div>
            </div>
            <Skeleton className="w-full h-10 rounded-lg border-2 border-dashed border-gray-200 dark:border-gray-700" />
          </div>
        </SkeletonCard>

        {/* Row 2: Balance and Total Expenses Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
          {/* User Balance Card - matches StatCard structure */}
          <SkeletonCard className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <SkeletonText className="w-24 h-4 mb-2" />
                <div className="flex items-baseline gap-2">
                  <SkeletonTitle className="w-32 h-8" />
                </div>
                <SkeletonText className="w-8 h-3 mt-1" />
              </div>
              <Skeleton className="w-8 h-8 rounded-full" />
            </div>
          </SkeletonCard>

          {/* Total Expenses Card - matches StatCard structure */}
          <SkeletonCard className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <SkeletonText className="w-28 h-4 mb-2" />
                <div className="flex items-baseline gap-2">
                  <SkeletonTitle className="w-28 h-8" />
                </div>
                <SkeletonText className="w-8 h-3 mt-1" />
              </div>
              <Skeleton className="w-8 h-8 rounded-full" />
            </div>
          </SkeletonCard>
        </div>

        {/* Row 3: Budget Widget - Full width */}
        <SkeletonCard className="p-4">
          <div className="space-y-4">
            {/* Header */}
            <div className="flex justify-between items-center">
              <SkeletonText className="w-16 h-4" />
              <SkeletonTitle className="w-12 h-6" />
            </div>
            {/* Progress bar */}
            <div className="space-y-2">
              <div className="flex justify-between">
                <SkeletonText className="w-12 h-3" />
                <SkeletonText className="w-12 h-3" />
              </div>
              <Skeleton className="w-full h-8 rounded-full" />
              <div className="flex justify-between">
                <SkeletonText className="w-6 h-2" />
                <SkeletonText className="w-6 h-2" />
                <SkeletonText className="w-6 h-2" />
                <SkeletonText className="w-6 h-2" />
                <SkeletonText className="w-6 h-2" />
              </div>
            </div>
            {/* Stats */}
            <div className="divide-y divide-gray-200 dark:divide-gray-700">
              {[1, 2, 3].map(i => (
                <div key={i} className="flex justify-between items-center py-2">
                  <SkeletonText className="w-16 h-4" />
                  <SkeletonText className="w-20 h-4" />
                </div>
              ))}
            </div>
          </div>
        </SkeletonCard>
      </div>

      {/* Recent Expenses Section - matches ExpensesSection */}
      <div className="space-y-4">
        <SkeletonTitle className="w-40 h-6" />

        {/* Search bar */}
        <Skeleton className="w-full h-10 rounded-lg" />

        {/* Expenses list - matches ExpensesTable loading skeleton structure */}
        <SkeletonCard className="overflow-hidden p-6">
          <div className="-mx-6">
            {[1, 2, 3, 4, 5].map(i => (
              <div
                key={i}
                className={`py-4 flex items-center justify-between gap-3 sm:gap-4 px-4 sm:px-6 ${
                  i !== 5 ? 'border-b border-gray-100 dark:border-gray-700' : ''
                }`}
              >
                <div className="flex items-center gap-3 flex-1">
                  <Skeleton className="w-10 h-10 sm:w-8 sm:h-8 rounded-lg" />
                  <div className="space-y-2 flex-1">
                    <Skeleton className="h-5 w-2/3" />
                    <Skeleton className="h-4 w-1/2" />
                  </div>
                </div>
                <div className="flex flex-col items-end gap-2">
                  <Skeleton className="h-5 w-20" />
                  <Skeleton className="h-8 w-16 rounded-lg" />
                </div>
              </div>
            ))}
          </div>
        </SkeletonCard>
      </div>
    </>
  );
}
